<app-protected-content [requiredRoles]="requiredRoles">
  <div class="dashboard-card-container">
    @let systems = systems$ | async;
    @for (system of systems; track system.name) {
      <app-dashboard-card
        [systemKey]="system.name"
        [healthStatus]="system.status"
      ></app-dashboard-card>
    }
  </div>
</app-protected-content>
